module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group-title', [_vm._v("滑动选择图片,生成后可在前一页面中查看")]), _vm._v(" "), _c('swiper', {
    attrs: {
      "aspect-ratio": 15 / 10,
      "list": _vm.imgList,
      "auto": false
    },
    model: {
      value: (_vm.demo01_index),
      callback: function($$v) {
        _vm.demo01_index = $$v
      },
      expression: "demo01_index"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 10px 20px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.createAndShow()
      }
    }
  }, [_vm._v("设为默认图片")])], 1), _vm._v(" "), _c('x-dialog', {
    staticClass: "dialog-demo",
    model: {
      value: (_vm.showQr),
      callback: function($$v) {
        _vm.showQr = $$v
      },
      expression: "showQr"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.qrCode
    }
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.showQr = false
      }
    }
  }, [_c('span', {
    staticClass: "vux-close"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-567510f1"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/UserCard.vue
// module id = 695
// module chunks = 0